import {Link } from "react-router-dom";
import ButtonEdit from "../../UI/ButtonEdit/ButtonEdit"; 
import {UserType} from '../../types/user'


type Props = {
  users: UserType[];
  submithandler: () => void;
  category: string
}

const TestPermitTable = ({users, submithandler, category}: Props) => {
  
    return (
        <table className="table table__permit">
                <thead>
                  <tr>
                    <th>Фамилия, имя</th>
                    <th>ИИН</th>
                    <th>Действие</th>
                  </tr>
                </thead>
                <tbody>
                  {users?.map(
                    (u) =>
                      u.active && (
                        <tr className="surname search__item" key={u.id}>
                          <td style={{ fontSize: 22 }}>
                            <Link
                              style={{
                                color: "#008b8b",
                                textDecoration: "underline",
                              }}
                              to={`/admin/users/${u.id}`}
                            >
                              {u.surname} {u.name}
                            </Link>
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              color: "#008b8b",
                              fontSize: 22,
                            }}
                          >
                            {u.iin}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <form
                              
                              onSubmit={submithandler}
                            >
                              <input
                                type="hidden"
                                name="user_id"
                                value={u.id}
                              />

                              {category && <input
                                            type="hidden"
                                            name="category_id"
                                            value={category}
                                          />}

                              <ButtonEdit label="Разрешить" />
                            </form>
                          </td>
                        </tr>
                      )
                  )}
                </tbody>
              </table>
    )
}


export default TestPermitTable